/*
 * @Author: Q in
 * @Date: 2025-04-28 10:10:42
 * @LastEditors: Q in
 * @LastEditTime: 2026-02-27 10:06:21
 * @FilePath: /yihao_web/src/store/index.js
 * @Description: vuex
 */
import Vue from 'vue';
import Vuex from 'vuex';
// import createPersistedState from "vuex-persistedstate"

Vue.use(Vuex);

const store = new Vuex.Store({
	state: {},

	getters: {},

	mutations: {},

	actions: {}
	// plugins: [
	//   createPersistedState({
	//     storage: window.sessionStorage
	//   })
	// ]
});

export default store;
